module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.scss
// module id = ./src/app/navigation/navigation.component.scss
// module chunks = main